module.exports = __webpack_public_path__ + "img/pixel-main-bg.878fef9c.jpg";